"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseTransform_1 = require("./BaseTransform");
var Transform_1 = require("./Transform");
var isArrayLike_1 = require("../../utils/isArrayLike");
var object_1 = require("../../utils/object");
var ObjectTransform = /** @class */ (function (_super) {
    __extends(ObjectTransform, _super);
    function ObjectTransform() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.applyObjectTransforms = function (rawObj, queryOptions, executionOptions) {
            var objectTransformOptions = _this.options.objectTransformOptions;
            if (typeof rawObj === 'object') {
                var obj_1 = object_1.deepMergeObjects({}, rawObj);
                var transforms = objectTransformOptions.transforms, fields = objectTransformOptions.fields;
                obj_1 = _this.applyTransforms(obj_1, transforms, queryOptions, executionOptions);
                if (fields && isArrayLike_1.isArrayLike(fields)) {
                    fields.forEach(function (field) {
                        var key = field.key, fieldTransforms = field.transforms;
                        if (fieldTransforms && isArrayLike_1.isArrayLike(fieldTransforms)) {
                            obj_1[key] = _this.applyTransforms(obj_1[key], fieldTransforms, queryOptions, executionOptions);
                        }
                    });
                }
                return obj_1;
            }
            return rawObj;
        };
        _this.applyTransforms = function (value, transforms, queryOptions, executionOptions) {
            if (transforms) {
                for (var _i = 0, transforms_1 = transforms; _i < transforms_1.length; _i++) {
                    var transformOptions = transforms_1[_i];
                    var transform = new Transform_1.Transform(transformOptions, _this.translationHelper, _this.callStackLevel);
                    value = transform.execute(value, queryOptions, executionOptions);
                }
            }
            return value;
        };
        return _this;
    }
    ObjectTransform.prototype.execute = function (queryResponse, queryOptions, executionOptions) {
        var _this = this;
        if (isArrayLike_1.isArrayLike(queryResponse)) {
            queryResponse = queryResponse.map(function (row) {
                return _this.applyObjectTransforms(row, queryOptions, executionOptions);
            });
        }
        else if (typeof queryResponse === 'object') {
            queryResponse = this.applyObjectTransforms(queryResponse, queryOptions, executionOptions);
        }
        return queryResponse;
    };
    return ObjectTransform;
}(BaseTransform_1.BaseTransform));
exports.ObjectTransform = ObjectTransform;
//# sourceMappingURL=ObjectTransform.js.map